/**
 * Whether `typed` is the team name the owner must type before deleting a team.
 *
 * The rule is shared with the mobile app's delete-team dialog, so both clients
 * accept the same input: exact and case-sensitive, ignoring only whitespace at
 * either end. Both sides are NFC-normalised first because team names are free
 * text from iOS, Android and browser keyboards, and the same "Ä" can be stored
 * as one code point or as "A" plus a combining mark. The two render
 * identically, so without normalising an owner could type the name exactly as
 * shown and never be allowed to delete.
 */
export function teamNameMatches(typed: string, teamName: string): boolean {
  return typed.trim().normalize('NFC') === teamName.trim().normalize('NFC')
}
